import { IStyle } from '@fluentui/react';

export const textOverflow: IStyle = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    overflow: 'hidden'
};

export const leftPanelBuilderBlock = {
    padding: '0px 16px'
};
